
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { IncomeData } from '@/types/statistics';

interface IncomeChartProps {
  data: IncomeData;
}

const IncomeChart: React.FC<IncomeChartProps> = ({ data }) => {
  const chartData = data.monthlyData.map(month => ({
    name: month.month,
    income: month.income,
    fill: '#8B5CF6', // Purple color
  }));

  const chartConfig = {
    income: { label: "Income", color: "#8B5CF6" },
  };

  return (
    <div className="w-full">
      <ChartContainer
        config={chartConfig}
        className="aspect-[4/2] md:aspect-[3/1] h-72"
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 30,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              tick={{ fontSize: 12 }}
              tickFormatter={(value) => `₺${value}`}
              tickLine={false}
              axisLine={false}
            />
            <ChartTooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  const data = payload[0].payload;
                  return (
                    <div className="rounded-lg border bg-background p-2 shadow-sm">
                      <div className="flex items-center gap-2">
                        <div
                          className="h-2 w-2 rounded"
                          style={{ backgroundColor: data.fill }}
                        />
                        <span className="font-medium">{data.name}</span>
                      </div>
                      <div className="mt-1">
                        <span>Income: ₺{data.income.toLocaleString()}</span>
                      </div>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Bar
              dataKey="income"
              radius={[4, 4, 0, 0]}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </ChartContainer>
    </div>
  );
};

export default IncomeChart;
